export default __webpack_public_path__ + "static/media/Darkfury Leggings.a39090fd.jpg";